import { useQuery } from 'react-query';

import { faultQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IFaultDefinition } from '../../types/Fault/FaultDefinition';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';

export default function useFault(id: string) {
  const { get } = useApiHelper();

  const fault = useQuery({
    queryKey: faultQueryKeys.detail(id),
    queryFn: () =>
      get<IDefaultResponseWithData<IFaultDefinition>>(
        `/v1/fault/definitions/${id}`
      ).then((res) => res.data.data),
    enabled: !!id,
  });

  return {
    fault,
  };
}
